var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prize-wheel"},[_c('div',{staticClass:"zp-main",style:({ transform: _vm.transform, transition: _vm.transition })},_vm._l((_vm.prizeList),function(item,index){return _c('div',{key:'prizeName' + index,staticClass:"prizeName",style:({
        transform: ("rotate(-" + (_vm.rotate * index + _vm.rotate / 2) + "deg)"),
      })},[_c('div',{class:[
          {
            'prize-content': item.img,
            'noicon-prize-content': !item.img,
          },
          'common-prize-content' ]},[_c('span',{class:item.name.length > 8 ? 'miniSize' : ''},[_vm._v(_vm._s(item.name))]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.img),expression:"item.img"}],staticClass:"item-img-wrap"},[_c('img',{attrs:{"src":item.img}})])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }